import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import CompanyPoliciesCmp from './components/CompanyPolicies';
import DeptAnnoucementCmp from './components/DeptAnnoucement';
import LatestNewsCmp from './components/LatestNews';
import InternalLinkCmp from './components/InternalLink';
import NotesCmp from './components/Notes';
import LatestOrderCmp from './components/LatestOrder';
import AssignedWorkCmp from './components/AssignedWork';

export default [
  {
    title: '',
    items: [
      {
        title: <FormattedMessage id="FD_CompanyPolicies" defaultMessage="" />,
        matchPath: '/tube/companyrules',
        linkComponent: <Link to="/tube/companyrules" />,
        icon: <CompanyPoliciesCmp/>,
        functionCode: ['CompanyRuleEmp', 'CompanyRuleHR'],
      },
      {
        title: <FormattedMessage id="FD_DeptAnnouncement" defaultMessage="" />,
        matchPath: '/tube/departmentnews',
        linkComponent: <Link to="/tube/departmentnews" />,
        icon: <DeptAnnoucementCmp/>,
        functionCode: ['DepartmentNewsEmp', 'DepartmentNewsHR', 'DepartmentNewsSup', 'DepartmentNewsSec'],
      },
      {
        title: <FormattedMessage id="FD_NewsMsg" defaultMessage="" />,
        matchPath: '/tube/companynews',
        linkComponent: <Link to="/tube/companynews" />,
        icon: <LatestNewsCmp/>,
        functionCode: ['AnnouncementEmp', 'AnnouncementHR'],
      },
      {
        title: <FormattedMessage id="FD_NewOrder" defaultMessage="" />,
        matchPath: '/tube/orders',
        linkComponent: <Link to="/tube/orders" />,
        icon: <LatestOrderCmp/>,
        functionCode: ['OrderEmp', 'OrderHR'],
      },
      {
        title: <FormattedMessage id="FD_Todo" defaultMessage="" />,
        matchPath: '/tube/assignmenttask',
        linkComponent: <Link to="/tube/assignmenttask" />,
        icon: <AssignedWorkCmp/>,
        functionCode: 'AssignmentTask',
      },
      {
        title: <FormattedMessage id="FD_Sticker" defaultMessage="" />,
        matchPath: '/tube/stickynotes',
        linkComponent: <Link to="/tube/stickynotes" />,
        icon: <NotesCmp/>,
        functionCode: 'Note',
      },
      {
        title: <FormattedMessage id="FD_InternalLink" defaultMessage="" />,
        matchPath: '/tube/internallinks',
        linkComponent: <Link to="/tube/internallinks" />,
        icon: <InternalLinkCmp />,
        functionCode: 'InternalSystemLink',
      },
    ],
  },

];



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/navigationConfig.js
 **/